'use client';

import dynamic from 'next/dynamic';

// This needs to be in a separate file to prevent the ad-freestar package from being bundled
const AdFreestar = dynamic(() => import('./AdFreestar'), { ssr: false });

export default AdFreestar;
